<div *ngIf="user; else unset" class="content">
  <app-header></app-header>
  <div class="content_step_area">
    <div class="content_step_area_step_title">
      <div *ngIf="isDropdownVisible;else invisible" class="content_step_area_step_title_setLang">
        <label class="content_step_area_step_title_setLang_label">{{ 'MyProfile_Choose_Language' | translate }}</label>
        <select (change)="updateLangOnClick($event)" class="content_step_area_step_title_setLang_select"
          [(ngModel)]="detectedLanguage">
          <option *ngFor="let lang of languages" [value]="lang.value">{{lang.value}}</option>
        </select>
      </div>
      <ng-template #invisible>
        <div></div>
      </ng-template>
      <div class="content_step_area_step_title_switcher">
        <app-switcher [stepNumber]="stepInfo.activeStepNumber" [isSSOUser]="user?.isSSO"></app-switcher>
      </div>
    </div>
    <div>
      <app-step-name [stepInfo]="stepInfo"></app-step-name>
    </div>
    <app-stepper [stepNumber]="stepInfo.activeStepNumber" [account]="account" [user]="user" (stepChanged)="onStepChanged($event)"
      (stepModelChanged)="onStepModelChanged($event)"></app-stepper>
  </div>
  <app-footer [isBackBtnVisible]="!isFirstStep" [isNextBtnDisabled]="isNextBtnDisabled"
    (pageChanged)="onPageChanged($event)">
  </app-footer>
</div>
<ng-template #unset>
  <div class="loading_page">
    <div class="loading_page_spinner">
      <div class="loading_page_spinner_cube1 loading_page_spinner_cube"></div>
      <div class="loading_page_spinner_cube2 loading_page_spinner_cube"></div>
      <div class="loading_page_spinner_cube4 loading_page_spinner_cube"></div>
      <div class="loading_page_spinner_cube3 loading_page_spinner_cube"></div>
    </div>
  </div>
</ng-template>